import { render, staticRenderFns } from "./openOrdersHistory.vue?vue&type=template&id=2a3babd0&"
import script from "./openOrdersHistory.vue?vue&type=script&lang=js&"
export * from "./openOrdersHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports